// import '@/assets/fontawesome/css/all.min.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import "@/assets/tailwind.css";
import '@vueup/vue-quill/dist/vue-quill.snow.css';

import { supabase } from "@/supabase";
import nquery from '@/noc/noc'
import { createApp } from 'vue'
import { createI18n } from 'vue-i18n';
import App from './App.vue'
import router from './router'
import store from './store'
import { createPinia } from 'pinia'
import { useLoadingStore } from '@/store/loading'
import { useAuthStore } from '@/store/auth'
import Swalx from 'sweetalert2';

import en from './locales/en.json';

const i18n = createI18n({
    legacy: false, // Untuk Vue 3 Composition API
    locale: localStorage.getItem('lang') || 'en', // Bahasa default
    fallbackLocale: 'en',
    messages: { en }
  });

window.noc = nquery

const fetchUsers = async () => {
    let data = await supabase.from("members").select();
    console.log(data)
};

// fetchUsers()

const app = createApp(App)
app.use(createPinia())
app.use(i18n)
app.config.globalProperties.$noc = nquery
app.config.globalProperties.$supabase = supabase
app.config.globalProperties.$loading = useLoadingStore()
app.config.globalProperties.$auth = useAuthStore()
app.config.globalProperties.$Swal = Swalx
app.use(store).use(router).mount('#app')
